import { Spin } from 'antd';
import { Suspense, lazy } from 'react';

import { useParams } from '@suntex.core/nav';
import { ModuleInfo } from '@suntex.fim/enums';
import { getFlags } from '@suntex.fim/flags';
import { useModuleById } from '@suntex.fim/framework';

import { ModuleLayout } from '../components/ModuleLayout';

import { IMAGE_DIRECTORY, SOUND_DIRECTORY, useModuleViewProps } from './shared';

const WDYKCanvasView = lazy(() =>
  import('@suntex.modules/wdyk').then((m) => ({ default: m.WDYKView })),
);

const WhatDoYouKnowReactView = lazy(() =>
  import('@suntex.modules/what-do-you-know').then((m) => ({
    default: m.WhatDoYouKnowReactView,
  })),
);

const WDYK_IMAGE_DIRECTORY = `${IMAGE_DIRECTORY}know-and-show/`;

export function WDYK() {
  const { secureLink } = useParams<{ secureLink: string }>();
  const viewProps = useModuleViewProps();

  const module = useModuleById(ModuleInfo.wdyk2);

  if (!module) {
    return <Spin />;
  }

  return (
    <ModuleLayout moduleId={ModuleInfo.wdyk2}>
      {secureLink ? (
        <Suspense fallback={<Spin />}>
          {getFlags().modules.wdyk.defaultToReactView ? (
            <WhatDoYouKnowReactView
              {...viewProps}
              module={module}
              moduleId={ModuleInfo.wdyk2}
              secureLink={secureLink}
              soundDirectory={SOUND_DIRECTORY}
              imageDirectory={WDYK_IMAGE_DIRECTORY}
            />
          ) : (
            <WDYKCanvasView
              {...viewProps}
              module={module}
              moduleId={ModuleInfo.wdyk2}
              secureLink={secureLink}
              soundDirectory={SOUND_DIRECTORY}
              imageDirectory={WDYK_IMAGE_DIRECTORY}
            />
          )}
        </Suspense>
      ) : (
        <div>Invalid link</div>
      )}
    </ModuleLayout>
  );
}
